import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { SharedModule } from '../../shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, SharedModule, TranslateModule],
  declarations: [NavbarComponent],
  exports: [NavbarComponent]
})

export class NavbarModule { }
